/**
 * ******************
 * SEARCH DROPDOWN JS
 * ******************
 */

/**
 * Variables
 *
 * @type {string}
 */
var liveSearchResults = document.querySelector('[data-js="live-search-results"]');
var searchButton = document.querySelector('[data-js="search-button"]');
var searchDropdown = document.querySelector('[data-js="search-dropdown"]');
var searchDropdownClassShow = 'search-dropdown_is_show';
var searchDropdownIsShow = false;
var searchInput = document.querySelector('[data-js="search-input"]');

/**
 * Function toggleDropdownSearch
 *
 * Controls the visibility of the dropdown
 */
function toggleDropdownSearch() {
    if(searchDropdownIsShow) {
        searchDropdownIsShow = false;
        searchDropdown.classList.remove(searchDropdownClassShow);
        document.removeEventListener('click', clickInsideSearchDropdown, true);
    } else {
        searchDropdownIsShow = true;
        clearDropdownSearch();
        searchDropdown.classList.add(searchDropdownClassShow);
        document.getElementById("search-box-input").focus();
        document.addEventListener('click', clickInsideSearchDropdown, true);
    }
}

/**
 * Function clearDropdownSearch
 *
 * Clean the form
 */
function clearDropdownSearch() {
    searchInput.value = '';
    liveSearchResults.innerHTML = '';
}

/**
 * Function clickInsideSearchDropdown
 *
 * Control the click inside the dropdown
 */
function clickInsideSearchDropdown() {
    var isClickInsideSearchButton = searchButton.contains(event.target);
    var isClickInsideSearchDropdown = searchDropdown.contains(event.target);

    if (!isClickInsideSearchButton && !isClickInsideSearchDropdown) {
        toggleDropdownSearch();
    }
}